<div matDialogTitle>Analyserar</div>
<div matDialogContent>
  Vänligen vänta...
</div>
